import React, {useEffect, useState} from "react";
import {Badge, Col, Modal, Row, Spinner} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import axios from "axios";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";
import Dropdown from "../../../../primer/Dropdown";
import Input from "../../../../common/Input";
import DateBox from "../../../../primer/DateBox";
import {
    getDefaultOptionByValue,
    getDOYOptions,
    getGreekCurrencyFormat,
    getOptionsByData, isEmpty,
    quickClone
} from "../../../../../_helpers/commonFunctions";
import EditableTable from "../../../../primer/Editable-Table";
import {getICCategoryOptions, getICTypeOptions} from "../../../../../_helpers/sharedmydata";
import {fixDocumentTaxesDisplay} from "../../../../../_helpers/helperFunctions";
import AdvancedCombobox from "../../../../primer/AdvancedCombobox";
import {FaExchangeAlt, FaFileInvoice} from "react-icons/fa";
import Alert from "react-bootstrap/esm/Alert";
import {MdCategory, MdOutlineCancel} from "react-icons/md";
import ChangeCategoryModal from "./changeCategoryModal";
import {formatPath, getFileNameFromPath, getMimeType, popExtension} from "../../Cloud/Components/constants";
import {TbReload} from "react-icons/tb";
import {useTranslation} from "../../../../../hooks/useTranslation";

const AISaveSaleModal = ({show, setShow, aiDoc, onSave, onReprocess, onDecline}) => {
    const {t} = useTranslation();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const advancedTypesSales = useSelector((state) => state.SETTINGS.settings.advancedTypesSales);
    const salesGeneralSettings = useSelector((state) => state.SALES_SETTINGS.salesGeneralSettings);
    const installations = useSelector((state) => state.COMPANY_DATA.companyInstallations);
    const installationOptions = getOptionsByData(installations, "installationMasterId", "address");
    const [legacySale, setLegacySale] = useState({});
    const [newSale, setNewSale] = useState({});
    const [loadingDraft, setLoadingDraft] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);

    const icCategory = getICCategoryOptions();
    const icType = getICTypeOptions();

    const [productListData, setProductListData] = useState([]);
    const [showChangeCategoryModal, setShowChangeCategoryModal] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState({});

    useEffect(() => {
        if (!show) {
            setNewSale({});
            setLoadingDraft(false);
        } else {
            onShow();
            onProductSearch(null, setProductListData);
        }
    }, [show])

    const handleUserControlProduct = (rowNumber) => {
        const cloneProducts = quickClone(newSale.products);
        const p = cloneProducts.find((el) => el.no === rowNumber);
        if (p.userSelected) { // Restore AI selection
            p.userSelected = false;
            const legacyProduct = legacySale.products.find((el) => el.no === rowNumber);
            p._id = legacyProduct._id || undefined;
            p.name = legacyProduct.name;
            p.code = legacyProduct.code;
        } else { // Enable user selection
            p.userSelected = true;
            delete p._id;
            p.name = "";
            p.code = "";
        }
        setNewSale({...newSale, products: cloneProducts});
    }

    const handleUserSelectProduct = (rowNumber, e) => {
        const cloneProducts = quickClone(newSale.products);
        const p = cloneProducts.find((el) => el.no === rowNumber);
        p._id = e.row._id;
        p.name = e.row.name;
        p.code = e.row.code;
        setNewSale({...newSale, products: cloneProducts});
    }

    const onProductSearch = (keyword, setData) => {
        const reqData = {
            company: company.id,
        }
        if (keyword) reqData.keyword = keyword;
        axios.get(`${process.env.REACT_APP_API_URL2}/category/get-product-list`, {
            headers: {'Content-Type': 'application/json'},
            params: reqData
        }).then((res) => {
            if (res.data.status === "200") {
                setData(res.data.data);
            } else {
                setData([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const openChangeCategoryModal = (rowData) => {
        setSelectedRowData(rowData);
        setShowChangeCategoryModal(true);
    }

    const productTableColumns = [
        {
            name: "Αρ.",
            field: "no",
            width: "5%",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Είδος",
            field: "name",
            width: "20%",
            editable: true,
            inputType: {
                type: 'custom-render',
                render: (rowData) => (
                    <React.Fragment>
                        {rowData?.userSelected ? (
                            <React.Fragment>
                                <AdvancedCombobox
                                    className="w-100 ac-select-dropdown"
                                    defaultValue={rowData.name}
                                    data={productListData}
                                    onChange={(e) => handleUserSelectProduct(rowData.no, e)}
                                    excludeColumns={[]}
                                    columns={[
                                        {label: "Κωδικός είδους", name: "code"},
                                        {label: "Όνομα είδους", name: "name"},
                                    ]}
                                    deleteEnable={false}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    key={Math.random()}
                                    onChangeSearch={onProductSearch}
                                />
                                <div className={"text-muted text-center"} style={{cursor: "pointer"}} onClick={() => handleUserControlProduct(rowData.no)}><u>Επαναφορά είδους AI</u></div>
                            </React.Fragment>
                        ) : (
                            <div className={"text-center"}>
                                {rowData.name}
                                <Badge bg={"primary"} title={"Αλλαγή είδους"} className={"ml-2"} style={{padding: "4px", cursor: "pointer"}} onClick={() => handleUserControlProduct(rowData.no)}>
                                    <FaExchangeAlt size={16} />
                                </Badge>
                                {isEmpty(rowData._id) && (
                                    <React.Fragment>
                                        <br/>
                                        <Badge bg={"primary"} title={"Αλλαγή κατηγορίας"} className={"ml-1"} style={{padding: "4px", cursor: "pointer"}} onClick={() => openChangeCategoryModal(rowData)}>
                                            <MdCategory size={16} /> {rowData.aiCategory}
                                        </Badge>
                                    </React.Fragment>
                                )}
                            </div>
                        )}
                    </React.Fragment>
                )
            }
        },
        {
            name: "Ποσότητα",
            field: "quantity",
            editable: false,
            width: "5%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Μον. Μέτρησης",
            field: "muLabel",
            editable: false,
            width: "5%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Φ.Π.Α. %",
            field: "vatPercentage",
            editable: false,
            width: "5%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Καθαρή Αξία",
            field: "netValue",
            editable: true,
            disabled: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
        {
            name: "Αξία Φ.Π.Α.",
            field: "vat",
            editable: true,
            disabled: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
        {
            name: "Τελική Αξία",
            field: "totalValue",
            editable: true,
            disabled: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
        {
            name: "Κατηγορία MyData",
            field: "classificationCategory",
            editable: true,
            width: "15%",
            inputType: {
                type: 'select',
                options: icCategory,
                config: {
                    disabled: true,
                }
            }
        },
        {
            name: "Τύπος MyData",
            field: "classificationType",
            editable: true,
            width: "15%",
            inputType: {
                type: 'select',
                options: icType,
                config: {
                    disabled: true,
                }
            }
        },
    ]

    const salesTaxesColumns = [
        {
            name: "Ποσοστό Φ.Π.Α. %",
            field: "vatPercentage",
            editable: false,
        },
        {
            name: "Καθαρή Αξία €",
            field: "netValue",
            editable: false,
        },
        {
            name: "Αξία Φ.Π.Α. €",
            field: "vatEuro",
            editable: false,
        },
        {
            name: "Παρακρατούμενοι Φόροι",
            field: "withholdTaxes",
            editable: false,
        },
        {
            name: "Λοιποί Φόροι",
            field: "otherTaxes",
            editable: false,
        },
        {
            name: "Τέλη",
            field: "fees",
            editable: false,
        },
        {
            name: "Χαρτόσημο (Ψηφ. τέλος συν.)",
            field: "stamp",
            editable: false,
        },
        {
            name: "Κρατήσεις",
            field: "deductions",
            editable: false,
        }
    ];

    const onShow = () => {
        setLoadingDraft(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
                docId: aiDoc.erp_draftDocument,
                section: "Sales",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                setNewSale(res.data.data);
                setLegacySale(res.data.data);
                setLoadingDraft(false);
            } else {
                setShow(false);
                toast.error("Σφάλμα κατά την άντληση εγγραφής.");
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        })
    }

    const getPaymentTypes = () => {
        if (salesGeneralSettings.paymentTypes) {
            return getOptionsByData(salesGeneralSettings.paymentTypes, "_id", "name");
        } else {
            return [];
        }
    }

    const getNewSaleDocumentTypes = () => {
        if (advancedTypesSales) {
            return getOptionsByData(advancedTypesSales.filter((el) => el.myDataType === aiDoc.myDataType), "_id", "name");
        } else {
            return [];
        }
    }

    const handleOnChange = (e, type, name) => {
        const prepChange = {};
        if (type === "dd") {
            if (name === "documentType") {
                prepChange.documentType = e.value;
                prepChange.documentTypeName = e.label;
            }
        }
        setNewSale({...newSale, ...prepChange});
    }

    const fetchFileAsBlobURL = async (fileName, filePath, attemptConversion = true) => {
        toast.info("Το αρχείο θα ανοίξει σύντομα...");
        try {
            const fetchResp = await axios.post(`${process.env.REACT_APP_API_URL2}/cloud/action`, {
                action: "fetch",
                attemptConversion: String(attemptConversion),
                currentPath: formatPath(filePath),
                company: company.id,
                year: company.year,
            });
            if (fetchResp.data.status === "200") {
                const fromConversion = fetchResp.data.fromConversion;
                const binaryString = atob(fetchResp.data.data);
                const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
                let mimeType = getMimeType(fileName);
                if (fromConversion) mimeType = "application/pdf";

                const blob = new Blob([byteArray], { type: mimeType });
                let blobUrl = URL.createObjectURL(blob);
                if (popExtension(fileName) === "pdf" || fromConversion) blobUrl += "#navpanes=0&view=Fit";

                return blobUrl;
            } else {
                return null;
            }
        } catch (err) {
            return null;
        }
    }

    const onFileOpen = async (o) => {
        const blobURL = await fetchFileAsBlobURL(getFileNameFromPath(o.filePath), o.filePath, true);
        if (blobURL) {
            window.open(blobURL, "_blank");
        } else {
            toast.error("Σφάλμα κατά την άντληση αρχείου.");
        }
        setTimeout(() => {
            URL.revokeObjectURL(blobURL);
        }, 1000)
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal95PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Καταχώρηση Πώλησης</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingDraft ? (
                        <div style={{textAlign: "center"}}>Γίνεται φόρτωση παρακαλώ περιμένετε...<Spinner size={"sm"} className={"ml-2"} animation={"border"} variant={"dark"} /></div>
                    ) : Object.keys(newSale).length > 0 ? (
                        <div>
                            <Row className={"mb-2"}>
                                <Col md={3}>
                                    <Dropdown
                                        name={"documentType"}
                                        label={"Τύπος Παραστατικού"}
                                        options={getNewSaleDocumentTypes()}
                                        defaultValue={getNewSaleDocumentTypes().find((el) => el.value === newSale.documentType) ? getNewSaleDocumentTypes().find((el) => el.value === newSale.documentType) : ""}
                                        key={Math.random()}
                                        required={true}
                                        onChange={(e) => handleOnChange(e, "dd", "documentType")}
                                    />
                                </Col>
                                <Col sm="12" md="4">
                                    <Dropdown
                                        className={"mb-0"}
                                        label={t("General.installation")}
                                        options={installationOptions}
                                        value={getDefaultOptionByValue(installationOptions, newSale.installation, 'value', 'label', 'value')}
                                        enabledValue={true}
                                        searchEnable={true}
                                        disabled={true}
                                        name="installation"
                                        onChange={(e) => handleOnChange(e, 'dd', 'installation')}
                                    />
                                </Col>
                                <Col md={1}>
                                    <Input
                                        name={"preNumber"}
                                        label={"Σειρά"}
                                        value={newSale.preNumber === "noprefix" ? "Κενή" : newSale.preNumber}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={1}>
                                    <Input
                                        name={"number"}
                                        label={"Αριθμός"}
                                        value={newSale.number}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={2}>
                                    <DateBox
                                        label={"Ημερομηνία"}
                                        name={"date"}
                                        selected={new Date(newSale.date)}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={1}>
                                    <Input
                                        name={"time"}
                                        label={"Ώρα"}
                                        value={newSale.time}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <Col md={3}>
                                    <Input
                                        name={"vat"}
                                        label={`ΑΦΜ Πελάτη`}
                                        value={newSale.vat}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"name"}
                                        label={"Όνομα"}
                                        value={newSale.clientName}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <Input
                                        name={"activity"}
                                        label={"Δραστηριότητα"}
                                        value={newSale.activity}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <Col md={3}>
                                    <Input
                                        name={"address"}
                                        label={"Διεύθυνση"}
                                        value={newSale.address}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"doy"}
                                        label={"ΔΟΥ"}
                                        value={getDOYOptions().find((el) => String(el.value) === newSale.doy) ? getDOYOptions().find((el) => String(el.value) === newSale.doy)?.label : newSale.doy}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"city"}
                                        label={"Πόλη"}
                                        value={newSale.city}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"pc"}
                                        label={"Ταχυδρομικός Κωδικός"}
                                        value={newSale.pc}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <Dropdown
                                        name={"paymentType"}
                                        label={"Τρόπος Πληρωμής"}
                                        options={getPaymentTypes()}
                                        defaultValue={getPaymentTypes().find((el) => el.value === newSale.paymentType) ? getPaymentTypes().find((el) => el.value === newSale.paymentType) : ""}
                                        key={Math.random()}
                                        disabled={true}
                                    />
                                </Col>
                                {(newSale.mark || newSale.uid) && (
                                    <Col md={7} className={"mt-2"}>
                                        <Alert variant={"secondary"}>
                                            <span><strong>M.AR.K Παραστατικού:</strong> {newSale.mark}</span><br/>
                                            {newSale.uid && (
                                                <React.Fragment>
                                                    <span><strong>UID Παραστατικού:</strong> {newSale.uid}</span><br/>
                                                </React.Fragment>
                                            )}
                                            {newSale.authCode && (
                                                <React.Fragment>
                                                    <span><strong>Authentication Code Παραστατικού:</strong> {newSale.authCode}</span><br/>
                                                </React.Fragment>
                                            )}
                                        </Alert>
                                    </Col>
                                )}
                                <Col md={2} className={"mt-2"}>
                                    {!isEmpty(aiDoc?.filePath) && (
                                        <Button size={"sm"} className={"mr-1"} onClick={() => onFileOpen(aiDoc)}>Προβολή Παραστατικού <FaFileInvoice size={18} /></Button>
                                    )}
                                    {!isEmpty(aiDoc?.myDataObject?.downloadingInvoiceUrl) && (
                                        <Button size={"sm"} className={"mr-1"} onClick={() => window.open(aiDoc.myDataObject.downloadingInvoiceUrl, "_blank")}>Προβολή Παραστατικού <FaFileInvoice size={18} /></Button>
                                    )}
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <EditableTable
                                    tableName={"AI Module New Sale Product List"}
                                    invoiceType={newSale.myDataType}
                                    key={Math.random()}
                                    actionButtons={{
                                        print: false,
                                        delete: false,
                                        export: false,
                                        edit: false,
                                    }}
                                    columns={productTableColumns}
                                    disabled={true}
                                    data={newSale.products}
                                    allowInsertRow={false}
                                    allowActions={false}
                                    allowToggleColumns={false}
                                    allowPrintResults={false}
                                />
                            </Row>
                            <Row className="d-flex justify-content-end">
                                <Col md={8} style={{position: "inherit"}}>
                                    <EditableTable
                                        tableName={"AI Module New Sale Taxes Totals"}
                                        className="sales-taxes-calculations"
                                        allowActions={false}
                                        key={Math.random()}
                                        data={fixDocumentTaxesDisplay(newSale, "sales")}
                                        columns={salesTaxesColumns}
                                        actionButtons={{
                                            print: false,
                                            delete: false,
                                            export: false,
                                            edit: false,
                                        }}
                                    />
                                </Col>
                                <Col md={4}>
                                    <table className="table table-bordered mb-3">
                                        <tbody>
                                        <tr>
                                            <td className="fw-bold">Συνολική Ποσότητα</td>
                                            <td>{newSale.totalQuantity}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Συνολική Καθαρή Αξία</td>
                                            <td>{getGreekCurrencyFormat(newSale.totalNetValue)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Συνολική Αξία Φ.Π.Α.</td>
                                            <td>{getGreekCurrencyFormat(newSale.totalVatValue)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Σύνολο Κρατήσεων</td>
                                            <td>{getGreekCurrencyFormat(newSale.totalDeductions)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Σύνολο Παρακρατούμενων Φόρων</td>
                                            <td>{getGreekCurrencyFormat(newSale.withHoldTaxes)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Σύνολο Φόρων</td>
                                            <td>{getGreekCurrencyFormat(newSale.totalTaxesAmount)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Συνολική Αξία</td>
                                            <td>{getGreekCurrencyFormat(newSale.totalAmount)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Πληρωτέο Ποσό</td>
                                            <td>{getGreekCurrencyFormat(newSale.paymentAmount)}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        </div>
                    ) : (
                        <React.Fragment></React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-danger" className={"mr-1"} onClick={() => onDecline(aiDoc)}>
                        <MdOutlineCancel size={16} /> Απόρριψη
                    </Button>
                    <Button variant="primary" className={"mr-1"} onClick={() => onReprocess(aiDoc)}>
                        <TbReload size={16} /> Επαναεπεξεργασία
                    </Button>
                    <Button variant="outline-primary" onClick={() => setShow(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => onSave(aiDoc, newSale, setLoadingSave)} disabled={loadingSave}>
                        Αποθήκευση {loadingSave && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>

            <ChangeCategoryModal
                show={showChangeCategoryModal}
                setShow={setShowChangeCategoryModal}
                defaultRowData={selectedRowData}
                callbackFunction={(aiCategory) => {
                    const cloneProducts = quickClone(newSale.products);
                    const idx = cloneProducts.findIndex((el) => el.no === selectedRowData.no);
                    if (idx >= 0) {
                        cloneProducts[idx].aiCategory = aiCategory;
                        setNewSale({...newSale, products: cloneProducts});
                    }
                }}
            />
        </React.Fragment>
    )
}

export default AISaveSaleModal;
